import { render } from "./padel-toast.template.html?vue&type=template&id=73c663e0&scoped=true"
import script from "./PadelToast.vue?vue&type=script&lang=ts"
export * from "./PadelToast.vue?vue&type=script&lang=ts"

import "./PadelToast.vue?vue&type=style&index=0&id=73c663e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-73c663e0"

export default script